export const APP_NAME = 'OpenData Live';

export const SNACKBAR_DURATION = 3500;

// Pagination
export const DEFAULT_PAGE = 1;
export const MIN_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_COUNT = 500;

// Canary tests
export const TEST_IDS = {
	login: {
		emailInput: 'login-email-input',
		passwordInput: 'login-password-input',
		continueButton: 'login-continue-button'
	},
	search: {
		quickSearchInput: 'quick-search-input',
		hcpSearchCard: 'hcp-search-card',
		hcoSearchCard: 'hco-search-card'
	},
	profile: {
		veevaId: 'veeva-id'
	}
};
